import { Nullable } from '../types/utilities.types';

export const capitalize = (text: Nullable<string>) => text?.replace(/\b(\w)/g, c => c.toUpperCase());

export const reverseString = (str: string) => {
  return str.split('').reverse().join('');
}